import * as contentful from "contentful";
import logMethods from "../utils/ProxyLogger";
import { createCache } from "../utils/cache";

const contentfulCache = createCache();

/**
 * @param {object} options
 * @param {'slug' | 'slugs' | 'list'} options.t
 * @param {'webinar' | 'tutorial' | 'standard' | 'solution' | 'series' | 'resource' | 'release-note' | 'integration' | 'institute' | 'plugin' | 'product' | 'guide' | 'blog' | 'other'} options.ct
 * @param {string | undefined} options.s
 * @param {string | undefined} options.c
 * @param {number | undefined} options.p
 * @param {object | undefined} options.f
 * @returns {string}
 */
export const createCacheKey = ({ t, ct, s, c, p, f }) => {
	const prefix = `${t}_${ct}`;

	if (t === "slug") {
		return `${prefix}_${s}`;
	}

	if (t === "list") {
		return `${prefix}_${c ?? "all"}_${p ?? "all"}_${f ? JSON.stringify(f) : "all"}`;
	}

	return prefix;
};

export const createClient = (props, preview, useCache = true) => {
	const { environment, space, accessToken, previewToken = null, proxy } = props;

	const deliveryConfig = {
		environment,
		space,
		accessToken,
		proxy,
	};

	const previewConfig = {
		environment,
		space,
		accessToken: previewToken,
		host: "preview.contentful.com",
		proxy,
	};

	const config = preview && previewToken ? previewConfig : deliveryConfig;
	const pureClient = contentful.createClient(config);
	const client = typeof window === "undefined" ? logMethods(pureClient) : pureClient;

	const getEntries = async (options, cacheKey = null) => {
		let localResp = null;

		if (cacheKey && useCache) {
			localResp = contentfulCache.get(cacheKey);
		}

		if (cacheKey && localResp && useCache) {
			// eslint-disable-next-line no-console
			console.log(`getEntries(${JSON.stringify(options)}): using cache with key '${cacheKey}'`);
		}

		return (
			localResp ??
			client.getEntries(options).then(resp => {
				if (cacheKey && !!resp && useCache) {
					contentfulCache.set(cacheKey, resp);
				}

				return resp;
			})
		);
	};

	return {
		getEntries,
	};
};
